import { render } from "./profile-head.vue?vue&type=template&id=42dee6ad&scoped=true"
import script from "./profile-head.vue?vue&type=script&lang=js"
export * from "./profile-head.vue?vue&type=script&lang=js"

import "./profile-head.vue?vue&type=style&index=0&id=42dee6ad&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dee6ad"]])

export default __exports__